module.exports = __webpack_public_path__ + "static/img/hzhb.a3e320c8.png";